import React from 'react';
import { HeroSection } from './components/HeroSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ProblemSection } from './components/ProblemSection';
import { SystemSection } from './components/SystemSection';
import { PreviewCarousel } from './components/PreviewCarousel';
import { BenefitsSection } from './components/BenefitsSection';
import { UrgencySection } from './components/UrgencySection';
import { ClosingSection } from './components/ClosingSection';
import { ComparisonSection } from './components/ComparisonSection';
import { MoreTestimonialsSection } from './components/MoreTestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { CostSection } from './components/CostSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <div className="min-h-screen bg-brand-primary text-brand-body" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <TestimonialsSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <SystemSection data-id="element-5" />
        <PreviewCarousel data-id="element-6" />
        <BenefitsSection data-id="element-7" />
        <UrgencySection data-id="element-8" />
        <ClosingSection data-id="element-9" />
        <ComparisonSection data-id="element-10" />
        <MoreTestimonialsSection data-id="element-11" />
        <GuaranteeSection data-id="element-12" />
        <FAQSection data-id="element-13" />
        <CostSection data-id="element-14" />
        <FinalCTASection data-id="element-15" />
      </main>
      <Footer data-id="element-16" />
      <WhatsAppButton data-id="element-17" />
      <SocialProofPopup data-id="element-18" />
    </div>;
}